import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import UsersPage from './pages/UsersPage';
import AboutPage from './pages/AboutPage';
import Layout from './components/Layout';
import './App.css';
import { CompaniesPage } from './pages/Companies';
import { CompanyPage } from './pages/Company';
import ProtectedRoute from './components/ProtectedRoutes';
import LoginPage from './pages/LoginPage';
import 'react-datepicker/dist/react-datepicker.css';
import DailySummaryPage from './pages/DailyReport';
import AssociateMetricsPage from './pages/AssociatesMetrics';
import CompanyEventLogsPage from './pages/Events';
import ChargeStrategiesPage from './pages/ChargeSystem';
import MonthlyAssociateSummary from './pages/MonthlyDetail';
import ProfilePage from './pages/Profile';
import { AlertProvider } from './components/AlertContext';

function App() {
  return (
    <AlertProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<ProtectedRoute />}
          >
            <Route element={<Layout />} >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/charges" element={<ChargeStrategiesPage />} />
              <Route path="/monthly_detail" element={<MonthlyAssociateSummary />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/events" element={<CompanyEventLogsPage />} />
              <Route path="/company" element={<CompanyPage />} />
              <Route path="/daily_report" element={<DailySummaryPage />} />
              <Route path="/associates_report" element={<AssociateMetricsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>
          </Route>
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </Router>
    </AlertProvider>
  );
}

export default App;
